/*
  COTANTIN「底鋲カバーの使用上の注意と替えどき」（sections/cotantin-guide-care.liquid）：ボタンのクリックを計測する。
  tack_care_cta（type＝subscription／single／chat）を Shopify のカスタマーイベントに流す。
  GA4 へはカスタムピクセル「ご一緒に → GA4」が中継する（ページの gtag は呼ばない。二重に数えないため）。
*/
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tack-cta]');
    if (!link) return;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('tack_care_cta', { type: link.getAttribute('data-tack-cta') });
      }
    } catch (e) { /* 計測の失敗で移動を止めない */ }
  });
})();
